import React, { Component } from "react";
import InputRow from "./InputRow";
import { handleAlphabetCheck, handleNumberCheck } from "../constants";
import PropTypes from "prop-types";
export default class Parent3 extends Component {
  render() {
    return (
      <div>
        <div>
          <InputRow
            name="select"
            data={this.props.relationshipData}
            required={this.props.deceased ? "" : "*"}
            errMsg={this.props.errRelation}
            value={this.props.relationship}
            onChange={(e) => this.props.relationshipUpdate(e)}
            rowName="Relationship to You"
            disabled={this.props.disabled}
            hover="Tell us how the person is related to you."
          />
          <InputRow
            name="text"
            rowName="First Name"
            required={this.props.deceased ? "" : "*"}
            errMsg={this.props.errFName}
            value={this.props.fName}
            onChange={(e) => {
              if (handleAlphabetCheck(e) === 1 || e === "") {
                this.props.onChangeFName(e);
              } else {
                alert("Please Enter Alphabets only!");
              }
            }}
            disabled={this.props.disableAll}
          />
          <InputRow
            name="text"
            rowName="Last Name"
            required={this.props.deceased ? "" : "*"}
            errMsg={this.props.errLName}
            value={this.props.lName}
            onChange={(e) => {
              if (handleAlphabetCheck(e) === 1 || e === "") {
                this.props.onChangeLName(e);
              } else {
                alert("Please Enter Alphabets only!");
              }
            }}
            disabled={this.props.disableAll}
          />
          <InputRow
            name="text"
            rowName="Mobile Number"
            required={"*"}
            errMsg={this.props.errMobile}
            value={this.props.mobileNumber}
            onChange={(e) => {
              if (handleNumberCheck(e) === 0) {
                this.props.onChangeNumber(e);
              } else {
                alert("Enter Numbers only!");
              }
            }}
            disabled={this.props.disableAll}
            hover={
              this.props.guardian
                ? "Insert the contact number of your guardian."
                : "Insert the contact number of your parent."
            }
          />
          <InputRow
            name="email"
            rowName="E-mail Address"
            required={""} // 4 is the father Id
            value={this.props.email}
            onChange={(val) => this.props.onChangeEmail(val)}
            errMsg={this.props.errEmail}
            hover={
              this.props.guardian
                ? "Insert the email address of your guardian."
                : "Insert the email address of your parent."
            }
          />
        </div>
      </div>
    );
  }
}
Parent3.propTypes = {
  relationshipData: PropTypes.array.isRequired,
  relationship: PropTypes.number.isRequired,
  relationshipUpdate: PropTypes.func,
  disabled: PropTypes.bool,
  disableAll: PropTypes.bool,
  prefixData: PropTypes.array.isRequired,
  selectedPrefix: PropTypes.number.isRequired,
  onChangeAddress: PropTypes.func.isRequired,
  onChangeCompany: PropTypes.func.isRequired,
  onChangeCompanyAddress: PropTypes.func.isRequired,
  onChangeEmail: PropTypes.func.isRequired,
  onChangeFName: PropTypes.func.isRequired,
  onChangeLName: PropTypes.func.isRequired,
  onChangeMName: PropTypes.func.isRequired,
  onChangeNumber: PropTypes.func.isRequired,
  onChangePrefix: PropTypes.func.isRequired,
  onChangeProfession: PropTypes.func.isRequired,
  onChangeIdNumber: PropTypes.func.isRequired,
  onChangeIsTKHEmployee: PropTypes.func.isRequired,
  fName: PropTypes.string.isRequired,
  mName: PropTypes.string.isRequired,
  lName: PropTypes.string.isRequired,
  profession: PropTypes.string.isRequired,
  company: PropTypes.string.isRequired,
  companyAddress: PropTypes.string.isRequired,
  mobileNumber: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  errEmail: PropTypes.string,
  errRelation: PropTypes.string,
  errPrefix: PropTypes.string,
  errFName: PropTypes.string,
  errMName: PropTypes.string,
  errLName: PropTypes.string,
  errProfession: PropTypes.string,
  errMobile: PropTypes.string,
  errIdNumber: PropTypes.string,
  deceased: PropTypes.bool,
  deceasedOption: PropTypes.bool,
  deceasedChange: PropTypes.func,
  emailRequired: PropTypes.bool,
  guardian: PropTypes.bool,
  isTKHEmployee: PropTypes.bool,
  idnumber: PropTypes.string,
};
